export default {"src":"/_next/static/media/active-search.72b40308.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};